import actions from '../actions/travelerSentimentsActions';
import {getSentimentHighlightsGraphQl} from '../api/sentimentHighlightsGraphQl';

async function fetchSentimentHighlights(store, action = {payload: {}}) {
    const {
        listingReducer: {listingId},
        systemReducer: {locale}
    } = store.getState();
    const {crisisType} = action.payload;

    const data = await getSentimentHighlightsGraphQl({listingId, crisisType, locale});

    if (data && data.travelerSentiments) {
        store.dispatch(actions.fetchSentimentHighlightsSuccess(data.travelerSentiments));
    }
}

export {fetchSentimentHighlights};
